export default __webpack_public_path__ + "assets/948f25d0fa862f7f057ff247815eeecd.png";